import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=493b9f8c&"
import script from "./sideBar.vue?vue&type=script&lang=js&"
export * from "./sideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QImg,QAvatar,QItemLabel,QItem,QItemSection,QExpansionItem,QIcon} from 'quasar'
component.options.components = Object.assign({QList,QImg,QAvatar,QItemLabel,QItem,QItemSection,QExpansionItem,QIcon}, component.options.components || {})
